
const Base64 = require('./Base64');

export class SkylarAPI {

	abortController;

	async request( path, body ) {
		const controller = this.abortController = new AbortController();
		const response = await fetch( path, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify( body ),
			signal: controller.signal
		});

		this.abortController = null;
		return response.json();
	}

	async recognize( audiofile ) {
		const file = await Base64.fromBlob( audiofile );
		const { text } = await this.request( '/api/recognize', { file } );
		return text;
	}

	async conversation( audio_or_text, reset_subject, interrupting ) {

		const body = {
			reset_subject: reset_subject || null,
			interrupting
		};

		if ( typeof audio_or_text === 'string' ) {
			body.message = audio_or_text;
		} else {
			body.file = await Base64.fromBlob( audio_or_text );
		}

		return await this.request( '/api/conversation', body );
	}

	async speech( text ) {
		const body = { text };
		let audiodata = null;
		const { audio_base64, messagedata } = await this.request( '/api/speech', body );

		if ( audio_base64 ) {
			const audioData = Base64.parse( audio_base64 );
			audiodata = new Blob( [audioData], { type: 'audio/mpeg' });
		}

		return { audiodata, messagedata };
	}

	// Cancel in-process request.
	cancelRequest() {
		if ( this.abortController ) {
			this.abortController.abort();
		}
	}
}
